/**
 * @generated SignedSource<<cbc67301b8118b37251dfdff45edb0c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type accountDeleteMutation$variables = {
  id: string;
};
export type accountDeleteMutation$data = {
  readonly deleteAccount: {
    readonly id: string;
  };
};
export type accountDeleteMutation = {
  variables: accountDeleteMutation$variables;
  response: accountDeleteMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AccountDeletePayload",
    "kind": "LinkedField",
    "name": "deleteAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2d2b837f07e5a37686a86da232be2aee",
    "id": null,
    "metadata": {},
    "name": "accountDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation accountDeleteMutation(\n  $id: ID!\n) {\n  deleteAccount(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8083c04265e9a155cd8514c1eda1cec3";

export default node;
